<template>
    <svg class="icon svg-icon" aria-hidden="true">
        <use v-bind:xlink:href="'#'+name"></use>
    </svg>
</template>

<script>
	export default {
		name: 'd-icon',
        props:{
			name:{
				type:String,
                default:'icon-icon_hyzx'
            }
        }
	}
</script>

<style lang="scss" scoped>
    .icon {
        width: 18px;
        height: 18px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
    }
</style>